import { render } from "./CouponListTierPage.vue?vue&type=template&id=099ff0b9&scoped=true"
import script from "./CouponListTierPage.vue?vue&type=script&lang=js"
export * from "./CouponListTierPage.vue?vue&type=script&lang=js"

import "./CouponListTierPage.vue?vue&type=style&index=0&id=099ff0b9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-099ff0b9"

export default script